export default function getFixedSelectors(selectors, activeRecord, records) {
  if (activeRecord) {
    //  const { districts, schools, teachers } = records
    let d
    if (activeRecord.role) {
      d = {
        districts: 'schoolDistrict',
        schools: 'school',
      }
    } else {
      d = {
        districts: 'district',
        school: 'school',
      }
    }
    // const r = {
    //   districts: 'School District',
    //   schools: 'School'
    // }
    let fixedSelectors = []
    const { fixed } = selectors
    fixed.forEach((selector) => {
      const lookup = d[selector]
      const id = activeRecord[lookup]
      const selected = records[selector][id]
      // const recordType = r[selector]
      fixedSelectors.push({name: selected.name || selected.fullName, recordType: selector})
    })
    return fixedSelectors
  } else return []
} 


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/getFixedSelectors.js